import { iframeResizer } from 'iframe-resizer';

export const autoResizeHeight = (iframeId: string) => {
    iframeResizer({ checkOrigin: false }, document.querySelector(iframeId));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).autoResizeHeight = autoResizeHeight;
